import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "searchField", "orderTypeFilter", "statusFilter", "list", "searchOptions"]

  connect() {
    this.originalList = Array.from(this.listTarget.children)
    this.performSearch()
    console.log("Order Search Controller")
  }

  search() {
    this.performSearch()
  }

  toggleSearchOptions(event) {
    this.searchOptionsTarget.classList.toggle("hidden")
  }

  performSearch() {
    const query = this.searchTarget.value.toLowerCase()
    const searchFields = this.searchFieldTargets.filter(cb => cb.checked).map(cb => cb.value)
    const orderTypeFilters = this.orderTypeFilterTargets.filter(cb => cb.checked).map(cb => cb.value)
    const statusFilters = this.statusFilterTargets.filter(cb => cb.checked).map(cb => cb.value)
  
    //console.log('Search Query:', query)
    //console.log('Search Fields:', searchFields)
    //console.log('Order Type Filters:', orderTypeFilters)
    //console.log('Status Filters:', statusFilters)
  
    const filteredList = this.originalList.filter(row => {
      const matchesSearch = searchFields.length === 0 || searchFields.some(field => {
        if (field === 'phone') {
          const phoneNumber = (row.dataset[field] || "").replace(/[-\s]/g, '')
          const queryNumbers = query.replace(/\D/g, '')
          return phoneNumber.includes(queryNumbers)
        }
        return (row.dataset[field] || "").toLowerCase().includes(query)
      })
      const matchesOrderType = orderTypeFilters.length === 0 || orderTypeFilters.includes(row.dataset.orderType)
      const matchesStatus = statusFilters.length === 0 || statusFilters.includes(row.dataset.status)
  
     // console.log('Row:', row.dataset)
     // console.log('Matches Order Type:', matchesOrderType, 'Row Order Type:', row.dataset.orderType)
//console.log('Matches Status:', matchesStatus, 'Row Status:', row.dataset.status)
  
      return matchesSearch && matchesOrderType && matchesStatus
    })
  
    this.updateList(filteredList)
  }

  updateList(list) {
    this.listTarget.innerHTML = ""
    list.forEach(row => this.listTarget.appendChild(row))
  }
}